export const collaborationSetup = {
  junior: {
    workflows: [
      { name: 'Daily Standups', description: 'Facilitate daily scrum meetings and remove impediments', frequency: 'Daily at 9 AM' },
      { name: 'Sprint Planning', description: 'Lead sprint planning sessions with development team', process: 'Define sprint goals and select backlog items' },
      { name: 'Backlog Refinement', description: 'Regular backlog grooming sessions', frequency: 'Weekly' }
    ],
    tools: [
      { name: 'Slack', purpose: 'Team communication and updates', channels: ['#product-owners', '#development-team', '#stakeholders'] },
      { name: 'JIRA', purpose: 'Backlog management and sprint planning', access: 'Product owner permissions' },
      { name: 'Confluence', purpose: 'Requirements documentation', permissions: 'Editor access to product spaces' }
    ],
    processes: [
      { name: 'User Story Creation', steps: ['Gather requirements', 'Write user stories', 'Define acceptance criteria', 'Estimate story points'] },
      { name: 'Sprint Review', steps: ['Demo completed features', 'Gather stakeholder feedback', 'Update product backlog', 'Plan next sprint'] }
    ]
  },
  mid: {
    workflows: [
      { name: 'Stakeholder Management', description: 'Regular stakeholder alignment and communication', frequency: 'Bi-weekly' },
      { name: 'Release Planning', description: 'Plan and coordinate product releases', commitment: 'Cross-team coordination' },
      { name: 'Product Roadmap Updates', description: 'Maintain and communicate product roadmap', scope: 'Strategic alignment with business goals' }
    ],
    tools: [
      { name: 'ProductBoard', purpose: 'Product roadmap and feature prioritization', access: 'Admin permissions' },
      { name: 'Amplitude', purpose: 'Product analytics and user insights', access: 'Analytics dashboard access' },
      { name: 'Miro', purpose: 'Collaborative planning and user story mapping', permissions: 'Board creation and facilitation' }
    ],
    processes: [
      { name: 'Release Planning', steps: ['Define release goals', 'Coordinate with multiple teams', 'Plan release timeline', 'Manage dependencies'] },
      { name: 'Stakeholder Alignment', steps: ['Conduct stakeholder meetings', 'Gather feedback', 'Align priorities', 'Communicate decisions'] }
    ]
  },
  senior: {
    workflows: [
      { name: 'Product Strategy Alignment', description: 'Align product ownership with overall product strategy', responsibility: 'Strategic product direction' },
      { name: 'Cross-functional Leadership', description: 'Lead cross-functional initiatives and programs', scope: 'Organization-wide product initiatives' },
      { name: 'Agile Transformation', description: 'Drive agile transformation and best practices', impact: 'Organizational agile maturity' }
    ],
    tools: [
      { name: 'Strategic Planning Platforms', purpose: 'Long-term product planning', role: 'Strategic planning facilitator' },
      { name: 'Advanced Analytics Suite', purpose: 'Product performance and business metrics', access: 'Executive dashboard access' },
      { name: 'Innovation Management Tools', purpose: 'Innovation pipeline and experimentation', role: 'Innovation program lead' }
    ],
    processes: [
      { name: 'Portfolio Management', steps: ['Assess product portfolio', 'Prioritize initiatives', 'Allocate resources', 'Monitor outcomes'] },
      { name: 'Organizational Alignment', steps: ['Facilitate leadership alignment', 'Drive strategic decisions', 'Communicate vision', 'Measure success'] }
    ]
  }
};
